// src/api/http.js
import axios from 'axios'

const configuredApi =
    process.env.REACT_APP_API_ORIGIN ||
    process.env.REACT_APP_API_BASE_URL ||
    window.location.origin

const normalizedApi = configuredApi.replace(/\/+$/, '')
const API_BASE = normalizedApi.endsWith('/api') ? normalizedApi : `${normalizedApi}/api`
const API_ORIGIN = API_BASE.replace(/\/api$/, '')

export const http = axios.create({
    baseURL: API_BASE,
    headers: {
        Accept: 'application/json',
    },
    withCredentials: true,
})

http.interceptors.request.use((config) => {
    const token =
        localStorage.getItem('token') ||
        localStorage.getItem('auth_token') ||
        localStorage.getItem('access_token')

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

export async function ensureSanctumCsrf() {
    await axios.get(`${API_ORIGIN}/sanctum/csrf-cookie`, {
        withCredentials: true,
    })
}
